import _ from 'lodash';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {withStyles} from "@material-ui/core/styles";
import WarningIcon from '@material-ui/icons/Warning';

const styles = () => {
	return {
		formulaContainer : {
			//border : '1px solid #eee',
			fontSize : 14,
			backgroundColor : '#f7f7f7',
			marginTop : 10,
			marginBottom : 5,
			border : '1px solid #ddd'
		},
		formulaTitle : {
			fontSize : 13,
			textTransform: 'uppercase',
			//fontWeight : 800,
			color : '#555',
			paddingTop : 7,
			backgroundColor : '#f0f0f0',
			padding: 7,
		},
		formulaSection : {
			padding: '0px 15px 15px 15px',
		},
		formulaRow : {
			display : 'flex',
			flexDirection : 'row',
			paddingBottom : 2,
		},
		formulaRowBreak : {
			display : 'flex',
			flexDirection : 'row',
			paddingBottom : 2,
			paddingTop : 20,
		},
		formulaSubTitle : {
			paddingTop : 20,
			display : 'flex',
			flexDirection : 'row',
			textAlign : 'left',
			borderBottom: '.5px solid #ddd',
			textTransform: 'uppercase',
			paddingBottom : 2,
			marginBottom: 10,
			color: '#555',
		},
		formulaTotal : {
			borderTop : '2px solid #ccc',
			paddingTop : '5px',
			marginTop : '5px',
			display : 'flex',
			flexDirection : 'row',
			fontWeight : '800',
			paddingBottom : '15px',
			fontSize : 16,
		},
		formulaSubtotal : {
			display : 'flex',
			flexDirection : 'row',
			fontWeight : '800',
			paddingBottom : 20,
		},
		formulaSubtotalLine : {
			height : 2,
			display : 'flex',
			marginLeft : '10%',
			marginRight : '10%',
			borderTop : '1px solid #ddd',
			paddingTop : '3px',
			marginTop : '3px',
			flexDirection : 'row',
			fontWeight : '800',
		},
		formulaLabel : {
			color : '#333',
			flexBasis : '70%',
			textAlign : 'right',
			paddingRight : '8px',
		},
		formulaValue : {
			color : '#666',
			flexBasis : '30%',
			textAlign : 'left',
		},
		warning : {
			color : '#FFC107',
			width : 14,
			height : 14,
			paddingRight : 3,
		},
	};
};

class Formula extends PureComponent {
	render () {
		const { formulaTitle, formulaRows = [], formulaNotes = [], classes,
			isBulk, isBiodiesel } = this.props;

		let title;
		if (formulaTitle) {
			title = formulaTitle;
		} else {
			if (isBulk) {
				title = 'Bulk Ethanol Pricing Formula';
			} else if (isBiodiesel) {
				title = 'Biodiesel Pricing Calculator';
			} else {
				title = 'E85 Pricing Calculator';
			}

		}

		return (<div className={classes.formulaContainer}>
			<div className={classes.formulaTitle}>{title}</div>
			<div className={classes.formulaSection}>

				{formulaRows.map((formulaRow, i) => {
					const {label, value, isSubtotal, isTotal, isTitle, notImplemented} = formulaRow;

					let className = 'formulaRow';
					if (isSubtotal) {
						className = 'formulaSubtotal';
					}
					else if (isTotal) {
						className = 'formulaTotal';
					}

					let displayValue = value;
					if (_.isNumber(displayValue) && !_.isNaN(displayValue)) {
						displayValue =  parseFloat(displayValue.toFixed(5)).toFixed(5);
					} else {
						displayValue = '???';
					}

					if (isTitle) {
						return (
							<div key={`fr${i}`} className={classes.formulaSubTitle}>
								{label}
							</div>
						);

					} else if (notImplemented) {
						return (
							<div key={`fr${i}`} className={classes.formulaRow}>
								<WarningIcon className={classes.warning}/> {label}
							</div>
						);
					} else {
						return (
							<div key={`fr${i}`}>
								{isSubtotal &&	<div className={classes.formulaSubtotalLine} />}
								<div className={classes[className]}>
									<div className={classes.formulaLabel}>{label}</div>
									<div className={classes.formulaValue}>{displayValue}</div>
								</div>
							</div>
						);
					}


				})}

				{!!formulaNotes.length &&
				<ul>
					{formulaNotes.map((note, i) => {
						return (
							<li key={`fn${i}`}>
								<div className={classes.formulaNote}>{note}</div>
							</li>
						);
					})}
				</ul>
				}
			</div>
		</div>);
	}
}

Formula.propTypes = {
	formulaRows : PropTypes.array.isRequired,
	formulaNotes : PropTypes.array,
	classes : PropTypes.object,
	isBulk : PropTypes.bool,
	isBiodiesel : PropTypes.bool,
	formulaTitle : PropTypes.string,
};

export default _.flow([
	withStyles(styles, { withTheme: true }),
])(Formula);

